<!-- POST Type 1: Original Post -->
<ng-container *ngIf="postData.PostType === 1">
    <article class="ts-post-card"
             [ngClass]="{
                'border-top': borders,
                'border-right': borders,
                'border-bottom': borders
             }">
        <div class="ts-post-card__main">
            <div class="ts-post-card__avatar">
                <div class="user-avatar-container">
                    <img class="circular-image" [src]="'api/content/logo?userID=' + postData?.UserID" alt="">
                </div>
            </div>
            <div class="ts-post-card__body">
                <header class="ts-post-card__header-row">
                    <div class="ts-post-card__meta">
                        <app-profile-menu [UserID]="UserID"
                                          [postUserId]="postData.UserID"
                                          [ProfileName]="postData.ProfileName"
                                          [Username]="postData.UserName"
                                          [PublishDate]="postData.PublishDate"
                                          [ImageDirectory]="postData?.ImageDirectory">
                        </app-profile-menu>
                        <span class="profile-link">&nbsp; &#x2022; &nbsp;</span>
                        <app-time-stamp-menu [InputDate]="postData.PublishDate">
                        </app-time-stamp-menu>
                        <app-score-menu [UserID]="UserID"
                                        [postUserId]="postData.UserID"
                                        [ProfileName]="postData.ProfileName"
                                        [Username]="postData.UserName"
                                        [PublishDate]="postData.PublishDate"
                                        [ImageDirectory]="postData?.ImageDirectory">
                        </app-score-menu>
                    </div>
                    <div *ngIf="pageType !== 'quote'" class="ts-post-card__menu" (click)="$event.stopPropagation()">
                        <app-three-dots-menu (postEditedOrDeleted)="refreshPosts()"
                                             [Username]="Username"
                                             [UserID]="UserID"
                                             [postUsername]="postData.UserName"
                                             [postUserId]="postData.UserID"
                                             [postId]="postData.TSID"
                                             [isUserPost]="postData.UserID === UserID"
                                             [userType]="postData.TrustLevel"
                                             [postType]="postData.PostType"
                                             [subscriptionLevel]="postData.SubscriptionLevel"
                                             [pageType]="pageType">
                        </app-three-dots-menu>
                    </div>
                </header>
                <a href="post-detail.html" class="post-title">{{postData.PostTitle}}</a>
                <p [innerHTML]="postData.PostContent | parseHashtags"></p>
                <app-media-carousel *ngIf="postData?.MediaItems?.length > 0" [UserID]="postData.UserID" [mediaItems]="postData.MediaItems" [responsiveOptions]="responsiveOptions"></app-media-carousel>
                <div *ngIf="pageType !== 'quote'" class="reactions ts-post-card__reactions">
                    <app-reactions [postData]="postData"
                                   [UserID]="UserID"
                                   (reactionsUpdated)="onReactionsUpdated(postData.TSID, $event)">
                    </app-reactions>
                </div>
            </div>
        </div>
    </article>
</ng-container>

<!-- POST Type 2: Repost -->
<ng-container *ngIf="postData.PostType === 2">
    <article class="ts-post-card ts-post-card--repost border-top border-right border-bottom">
        <app-profile-menu-repost [UserID]="UserID"
                                 [postUserId]="postData.UserID"
                                 [ProfileName]="postData.ProfileName"
                                 [Username]="postData.UserName"
                                 [PublishDate]="postData.PublishDate"
                                 [ImageDirectory]="postData.ImageDirectory">
        </app-profile-menu-repost>
        <div class="ts-post-card__main ts-post-card__main--after-repost">
            <div class="ts-post-card__avatar">
                <div class="user-avatar-container">
                    <img class="circular-image" [src]="postData.ImageDirectory + '/' + postData.OrigUserImg" alt="" height="50px">
                </div>
            </div>
            <div class="ts-post-card__body">
                <header class="ts-post-card__header-row">
                    <div class="ts-post-card__meta">
                        <app-profile-menu [UserID]="UserID"
                                          [postUserId]="postData.OrigUserID"
                                          [ProfileName]="postData.OrigProfileName"
                                          [Username]="postData.OrigUserName"
                                          [PublishDate]="postData.PublishDate"
                                          [ImageDirectory]="postData.ImageDirectory">
                        </app-profile-menu>
                        <span class="profile-link">&nbsp; &#x2022; &nbsp;</span>
                        <app-time-stamp-menu [InputDate]="postData.PublishDate">
                        </app-time-stamp-menu>
                        <app-score-menu [UserID]="UserID"
                                        [postUserId]="postData.OrigUserID"
                                        [ProfileName]="postData.OrigProfileName"
                                        [Username]="postData.OrigUserName"
                                        [PublishDate]="postData.PublishDate"
                                        [ImageDirectory]="postData?.ImageDirectory">
                        </app-score-menu>
                    </div>
                    <div class="ts-post-card__menu" (click)="$event.stopPropagation()">
                        <app-three-dots-menu (postEditedOrDeleted)="refreshPosts()"
                                             [Username]="Username"
                                             [UserID]="UserID"
                                             [postUsername]="postData.OrigUserName"
                                             [postUserId]="postData.OrigUserID"
                                             [postId]="postData.TSID"
                                             [isUserPost]="postData.OrigUserID === UserID"
                                             [userType]="postData.TrustLevel"
                                             [postType]="postData.PostType"
                                             [subscriptionLevel]="postData.SubscriptionLevel"
                                             [pageType]="pageType">
                        </app-three-dots-menu>
                    </div>
                </header>
                <a href="post-detail.html" class="post-title">{{postData.PostTitle}}</a>
                <p [innerHTML]="postData.PostContent | parseHashtags"></p>
                <app-media-carousel *ngIf="postData.MediaItems" [UserID]="postData.OrigUserID" [mediaItems]="postData.MediaItems" [responsiveOptions]="responsiveOptions"></app-media-carousel>
                <div *ngIf="pageType !== 'quote'" class="reactions ts-post-card__reactions">
                    <app-reactions [postData]="postData" [UserID]="UserID" (reactionsUpdated)="onReactionsUpdated(postData.TSID, $event)"></app-reactions>
                </div>
            </div>
        </div>
    </article>
</ng-container>

<ng-container *ngIf="postData.PostType === 3">
    <!-- share video post -->
</ng-container>

<ng-container *ngIf="postData.PostType === 4">
    <article class="ts-post-card ts-post-card--reply border-right">
        <div class="ts-post-card__main">
            <div class="ts-post-card__avatar">
                <div class="user-avatar-container">
                    <ng-container *ngIf="postData.ImageDirectory; else noImageDirectory">
                        <img class="circular-image" [src]="postData?.ImageDirectory + '/' + postData?.UserImg" alt="" height="50px">
                    </ng-container>
                    <ng-template #noImageDirectory>
                        <ng-container *ngIf="postData.UserImg">
                            <img class="profile-image" [src]="'/img_profile/' + postData.UserID + '/' + postData.UserImg" alt="User Profile">
                        </ng-container>
                    </ng-template>
                </div>
            </div>
            <div class="ts-post-card__body">
                <header class="ts-post-card__header-row">
                    <div class="ts-post-card__meta">
                        <app-profile-menu [UserID]="UserID"
                                          [postUserId]="postData.UserID"
                                          [ProfileName]="postData.ProfileName"
                                          [Username]="postData.UserName"
                                          [PublishDate]="postData.PublishDate"
                                          [ImageDirectory]="postData?.ImageDirectory">
                        </app-profile-menu>
                        <span class="profile-link">&nbsp; &#x2022; &nbsp;</span>
                        <app-time-stamp-menu [InputDate]="postData.PublishDate">
                        </app-time-stamp-menu>
                        <app-score-menu [UserID]="UserID"
                                        [postUserId]="postData.UserID"
                                        [ProfileName]="postData.ProfileName"
                                        [Username]="postData.UserName"
                                        [PublishDate]="postData.PublishDate"
                                        [ImageDirectory]="postData?.ImageDirectory">
                        </app-score-menu>
                    </div>
                    <div class="ts-post-card__menu" (click)="$event.stopPropagation()">
                        <app-three-dots-menu (postEditedOrDeleted)="refreshPosts()"
                                             [Username]="Username"
                                             [UserID]="UserID"
                                             [postUsername]="postData.UserName"
                                             [postUserId]="postData.UserID"
                                             [postId]="postData.TSID"
                                             [isUserPost]="postData.UserID === UserID"
                                             [userType]="postData.TrustLevel"
                                             [postType]="postData.PostType"
                                             [subscriptionLevel]="postData.SubscriptionLevel"
                                             [pageType]="pageType">
                        </app-three-dots-menu>
                    </div>
                </header>
                <a href="post-detail.html" class="post-title">{{postData.PostTitle}}</a>
                <p [innerHTML]="postData.PostContent | parseHashtags"></p>
                <app-media-carousel *ngIf="postData?.MediaItems?.length > 0" [UserID]="postData.UserID" [mediaItems]="postData.MediaItems" [responsiveOptions]="responsiveOptions"></app-media-carousel>
                <div class="reactions ts-post-card__reactions">
                    <app-reactions [postData]="postData"
                                   [UserID]="UserID"
                                   (reactionsUpdated)="onReactionsUpdated(postData.TSID, $event)"></app-reactions>
                </div>
            </div>
        </div>
    </article>
</ng-container>

<!-- POST Type 5: Quote Post -->
<ng-container *ngIf="postData.PostType === 5">
    <article class="ts-post-card border-top border-right border-bottom">
        <div class="ts-post-card__main">
            <div class="ts-post-card__avatar">
                <div class="user-avatar-container">
                    <img class="circular-image" [src]="'api/content/logo?userID=' + postData?.UserID" alt="">
                </div>
            </div>
            <div class="ts-post-card__body">
                <header class="ts-post-card__header-row">
                    <div class="ts-post-card__meta">
                        <app-profile-menu [UserID]="UserID"
                                          [postUserId]="postData.UserID"
                                          [ProfileName]="postData.ProfileName"
                                          [Username]="postData.UserName"
                                          [PublishDate]="postData.PublishDate"
                                          [ImageDirectory]="postData?.ImageDirectory">
                        </app-profile-menu>
                        <span class="profile-link">&nbsp; &#x2022; &nbsp;</span>
                        <app-time-stamp-menu [InputDate]="postData.PublishDate">
                        </app-time-stamp-menu>
                        <app-score-menu [UserID]="UserID"
                                        [postUserId]="postData.UserID"
                                        [ProfileName]="postData.ProfileName"
                                        [Username]="postData.UserName"
                                        [PublishDate]="postData.PublishDate"
                                        [ImageDirectory]="postData?.ImageDirectory">
                        </app-score-menu>
                    </div>
                    <div class="ts-post-card__menu" (click)="$event.stopPropagation()">
                        <app-three-dots-menu (postEditedOrDeleted)="refreshPosts()"
                                             [Username]="Username"
                                             [UserID]="UserID"
                                             [postUsername]="postData.UserName"
                                             [postUserId]="postData.UserID"
                                             [postId]="postData.TSID"
                                             [isUserPost]="postData.UserID === UserID"
                                             [userType]="postData.TrustLevel"
                                             [postType]="postData.PostType"
                                             [subscriptionLevel]="postData.SubscriptionLevel"
                                             [pageType]="pageType">
                        </app-three-dots-menu>
                    </div>
                </header>
                <a href="post-detail.html" class="post-title">{{postData.PostTitle}}</a>
                <p [innerHTML]="postData.PostContent | parseHashtags"></p>
                <app-media-carousel *ngIf="postData.MediaItems" [UserID]="postData.UserID" [mediaItems]="postData.MediaItems" [responsiveOptions]="responsiveOptions"></app-media-carousel>

                <div class="original-post rounded-cust border-left border-top border-right border-bottom ts-post-card__quoted-wrap"
                     (click)="navigateToPost(postData.UserName, postData.QuotedPosts.QuotedOriginalPostID)">
                    <ng-container *ngIf="postData.QuotedPosts">
                        <div class="quoted-post">
                            <ng-container *ngIf="!postData.QuotedPosts?.QuotedIsDeleted; else unavailablePost">
                                <div class="ts-post-card__main ts-post-card__main--nested">
                                    <div class="ts-post-card__avatar">
                                        <div class="user-avatar-container">
                                            <img class="circular-image" [src]="'api/content/logo?userID=' + postData?.QuotedPosts.QuotedUserID" alt="">
                                        </div>
                                    </div>
                                    <div class="ts-post-card__body">
                                        <header class="ts-post-card__header-row">
                                            <div class="ts-post-card__meta">
                                                <app-profile-menu [UserID]="UserID"
                                                                  [postUserId]="postData.QuotedPosts.QuotedUserID"
                                                                  [ProfileName]="postData.QuotedPosts.QuotedProfileName"
                                                                  [Username]="postData.QuotedPosts.QuotedUserName"
                                                                  [PublishDate]="postData.QuotedPosts.QuotedPublishDate"
                                                                  [ImageDirectory]="postData.QuotedPosts.QuotedUserImg">
                                                </app-profile-menu>
                                                <span class="profile-link">&nbsp; &#x2022; &nbsp;</span>
                                                <app-time-stamp-menu [InputDate]="postData.QuotedPosts.QuotedPublishDate">
                                                </app-time-stamp-menu>
                                                <app-score-menu [UserID]="UserID"
                                                                [postUserId]="postData.QuotedPosts.QuotedUserID"
                                                                [ProfileName]="postData.QuotedPosts.QuotedProfileName"
                                                                [Username]="postData.QuotedPosts.QuotedUserName"
                                                                [PublishDate]="postData.QuotedPosts.QuotedPublishDate"
                                                                [ImageDirectory]="postData.QuotedPosts.QuotedUserImg">
                                                </app-score-menu>
                                            </div>
                                        </header>
                                        <p *ngIf="postData.QuotedPosts?.QuotedPostContent" [innerHTML]="postData.QuotedPosts.QuotedPostContent | parseHashtags "></p>
                                        <app-media-carousel *ngIf="postData.QuotedPosts.QuotedMediaItems" [UserID]="postData.QuotedPosts.QuotedUserID" [mediaItems]="postData.QuotedPosts.QuotedMediaItems" [responsiveOptions]="responsiveOptions"></app-media-carousel>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #unavailablePost>
                                <div class="text-muted">
                                    This post is unavailable.
                                </div>
                            </ng-template>
                        </div>
                    </ng-container>
                </div>

                <div *ngIf="pageType !== 'quote'" class="reactions ts-post-card__reactions">
                    <app-reactions [postData]="postData" [UserID]="UserID" (reactionsUpdated)="onReactionsUpdated(postData.TSID, $event)"></app-reactions>
                </div>
            </div>
        </div>
    </article>
</ng-container>

<ng-container *ngIf="postData.PostType === 6">
    <!-- gif image post -->
</ng-container>
<ng-container *ngIf="postData.PostType === 7">
    <!-- share link -->
</ng-container>
<ng-container *ngIf="postData.PostType === 8">
    <!-- share video -->
</ng-container>
<ng-container *ngIf="postData.PostType === 9">
    <!-- video playlist carousel -->
</ng-container>
<ng-container *ngIf="postData.PostType === 10">
    <!-- post sell book -->
</ng-container>
<ng-container *ngIf="postData.PostType === 11">
    <!-- advertisment carousel -->
</ng-container>

<ng-container *ngIf="postData.PostType === 20">
    <article class="ts-post-card border-top border-right border-bottom">
        <div class="ts-post-card__main">
            <div class="ts-post-card__avatar">
                <div class="user-avatar-container">
                    <img class="circular-image" [src]="postData.ImageDirectory + '/' + postData.UserImg" alt="" height="50px">
                </div>
            </div>
            <div class="ts-post-card__body">
                <div class="ts-post-card__meta ts-post-card__meta--stacked">
                    <app-profile-menu [UserID]="UserID"
                                      [postUserId]="postData.UserID"
                                      [ProfileName]="postData.ProfileName"
                                      [Username]="postData.UserName"
                                      [PublishDate]="postData.PublishDate"
                                      [ImageDirectory]="postData.ImageDirectory">
                    </app-profile-menu>
                    <span class="profile-link">&nbsp; &#x2022; &nbsp;</span>
                    <app-time-stamp-menu [InputDate]="postData.PublishDate">
                    </app-time-stamp-menu>
                    <app-score-menu [UserID]="UserID"
                                    [postUserId]="postData.UserID"
                                    [ProfileName]="postData.ProfileName"
                                    [Username]="postData.UserName"
                                    [PublishDate]="postData.PublishDate"
                                    [ImageDirectory]="postData?.ImageDirectory">
                    </app-score-menu>
                </div>
                <a href="post-detail.html" class="post-title">{{postData.PostTitle}}</a>
                <ng-container *ngIf="isTwitterPost(postData.PostContent)">
                    <div [innerHTML]="postData.PostContent | parseHashtags" class="twitter-post"></div>
                </ng-container>
                <ng-container *ngIf="isFacebookPostType(postData.PostContent)">
                    <ng-container *ngIf="isFacebookEmbeddedPost(postData.PostContent); else linkPosts">
                        <div [innerHTML]="postData.PostContent | parseHashtags"
                             [ngClass]="{'fb-post-embedded': isFacebookPostType(postData.PostContent), 'twitter-post': isTwitterPost(postData.PostContent)}">
                        </div>
                    </ng-container>
                    <ng-template #linkPosts>
                        <ng-container *ngIf="!isFacebookPost(postData.PostContent)">
                            <div class="fb-video"
                                 [attr.data-href]="postData.PostContent"
                                 data-width="500"
                                 data-show-text="false">
                                <div class="fb-xfbml-parse-ignore">
                                    <blockquote [attr.cite]="postData.PostContent">
                                        <a [attr.href]="postData.PostContent"></a>
                                    </blockquote>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isFacebookPost(postData.PostContent)">
                            <div class="fb-post"
                                 [attr.data-href]="postData.PostContent"
                                 data-width="500">
                            </div>
                        </ng-container>
                    </ng-template>
                </ng-container>
                <div *ngIf="postData.FileName">
                    <div class="video-container" *ngIf="postData.VideoMimeType?.startsWith('video/')">
                        <video controls class="responsive-video">
                            <source [src]="'api/content/media?fileName=' + postData.FileName + '&mimeType=' + postData.VideoMimeType + '&userID=' + postData.OrigUserID" [type]="postData.VideoMimeType">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div class="image-container" *ngIf="postData.VideoMimeType?.startsWith('image/')">
                        <div class="responsive-image-wrapper">
                            <img class="responsive-image" [src]="'api/content/media?fileName=' + postData.FileName + '&mimeType=' + postData.VideoMimeType + '&userID=' + postData.OrigUserID" [alt]="postData.FileName">
                        </div>
                    </div>
                </div>
                <div class="reactions ts-post-card__reactions">
                    <app-reactions [postData]="postData" [UserID]="UserID" (reactionsUpdated)="onReactionsUpdated(postData.TSID, $event)"></app-reactions>
                </div>
            </div>
        </div>
    </article>
</ng-container>

<ng-container *ngIf="postData.PostType === 21">
    <article class="ts-post-card border-top border-right border-bottom">
        <div class="ts-post-card__main">
            <div class="ts-post-card__avatar">
                <div class="user-avatar-container">
                    <img class="circular-image" [src]="postData.ImageDirectory + '/' + postData.UserImg" alt="" height="50px">
                </div>
            </div>
            <div class="ts-post-card__body">
                <div class="ts-post-card__meta ts-post-card__meta--stacked">
                    <app-profile-menu [UserID]="UserID"
                                      [postUserId]="postData.UserID"
                                      [ProfileName]="postData.ProfileName"
                                      [Username]="postData.UserName"
                                      [PublishDate]="postData.PublishDate"
                                      [ImageDirectory]="postData.ImageDirectory">
                    </app-profile-menu>
                </div>
                <a href="post-detail.html" class="post-title">{{postData.PostTitle}}</a>
                <div *ngIf="postData.FileName">
                    <div class="video-container" *ngIf="postData.VideoMimeType?.startsWith('video/')">
                        <video controls class="responsive-video">
                            <source [src]="'api/content/media?fileName=' + postData.FileName + '&mimeType=' + postData.VideoMimeType + '&userID=' + postData.OrigUserID" [type]="postData.VideoMimeType">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div class="image-container" *ngIf="postData.VideoMimeType?.startsWith('image/')">
                        <div class="responsive-image-wrapper">
                            <img class="responsive-image" [src]="'api/content/media?fileName=' + postData.FileName + '&mimeType=' + postData.VideoMimeType + '&userID=' + postData.OrigUserID" [alt]="postData.FileName">
                        </div>
                    </div>
                </div>
                <div class="reactions ts-post-card__reactions">
                    <app-reactions [postData]="postData" [UserID]="UserID" (reactionsUpdated)="onReactionsUpdated(postData.TSID, $event)"></app-reactions>
                </div>
            </div>
        </div>
    </article>
</ng-container>
